import { Typography } from '@mui/material';
import { getCompanyLoginStatus } from 'lib/api/express';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import PruffConnectBillingPortal from 'pages/PruffConnect/Billing';
import AutoEnrollment from 'pages/PruffConnect/Common/AutoEnrollment';
import WaitingForAuthorization from 'pages/PruffConnect/Common/WaitingForAuthorization';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import PruffConnectLayout from './layouts/PruffConnect';
import PruffConnectHome from './pages/PruffConnect';
import Credit from './pages/PruffConnect/Credit';
import Factoring from './pages/PruffConnect/Factoring';
import Settings from './pages/PruffConnect/Settings';
import SGR from './pages/PruffConnect/SGR';
import { RootState } from './services/redux/store';

const PruffConnectRoutes: React.FC = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const { data, isPending } = getCompanyLoginStatus(
    dispatch,
    auth.user?.clientId,
  );

  const canLogIn = useMemo(() => data?.canLogIn, [data]);
  const isEnrolled = useMemo(() => data?.isEnrolled, [data]);

  const ShortLayout = (props: { children: React.ReactNode }) => {
    const { children } = props;
    return (
      <div>
        <PruffConnectLayout>{children}</PruffConnectLayout>
      </div>
    );
  };
  if (!auth.user?.clientId)
    return (
      <Typography variant="h1">
        No se ha encontrado el cliente. Reinicia tu navegador
      </Typography>
    );

  if (isPending) return <CenteredCircularProgress />;
  if (!canLogIn) {
    if (!isEnrolled) {
      return (
        <div>
          <AutoEnrollment addLoguot />
        </div>
      );
    } else {
      return (
        <div>
          <WaitingForAuthorization />
        </div>
      );
    }
  }

  return (
    <div>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <ShortLayout>
                <PruffConnectHome />
              </ShortLayout>
            }
          />
          <Route
            path="/factoring/:page"
            element={
              <ShortLayout>
                <Factoring />
              </ShortLayout>
            }
          />
          <Route
            path="/sgr"
            element={
              <ShortLayout>
                <SGR />
              </ShortLayout>
            }
          />
          <Route
            path="/credit"
            element={
              <ShortLayout>
                <Credit />
              </ShortLayout>
            }
          />
          <Route
            path="/billing"
            element={
              <ShortLayout>
                <PruffConnectBillingPortal />
              </ShortLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <ShortLayout>
                <Settings />
              </ShortLayout>
            }
          />
          <Route path="*" element={<Navigate to={`/`} replace />} />
        </Routes>
      </Router>
    </div>
  );
};

export default PruffConnectRoutes;
